var exports = {
  "kL": "xfd349460--540631--container",
  "pq": "xfd349460--540631--info",
  "_R": "xfd349460--540631--close-button",
  "V9": "xfd349460--540631--info-section",
  "VY": "xfd349460--540631--info-block",
  "uB": "xfd349460--540631--contact-button",
  "Up": "xfd349460--540631--view",
};

module.exports = exports;
